import deviceSizes from 'constants/deviceSizes';
import { debounce } from 'lodash';
import { useEffect, useMemo, useState } from 'react';

const isSSR = typeof window === 'undefined';

const useWindowSize = (threshHold = deviceSizes.numbers.md) => {
  const [windowSize, setWindowSize] = useState({
    width: isSSR ? 1200 : window.innerWidth,
    height: isSSR ? 800 : window.innerHeight,
  });

  const updateWindowSize = debounce(() => {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  }, 500);

  useEffect(() => {
    window.addEventListener('resize', updateWindowSize);

    return () => {
      window.removeEventListener('resize', updateWindowSize);
    };
  }, []);

  const isMobile = useMemo(() => windowSize.width <= threshHold, [windowSize.width]);

  return {
    width: windowSize.width,
    height: windowSize.height,
    isMobile,
  };
};

export default useWindowSize;
